import Switch from "@mui/material/Switch";
import { HTMLAttributes } from "react";
import { Control, Controller, FieldValues, Path } from "react-hook-form";
import { LabelContainer } from "../assets/style";

interface HookFormSwitchProps<T extends FieldValues> {
    title: any
    style?: any
    name: Path<T>
    control: Control<T>
}

const HookFormSwitch = <T extends FieldValues>(props: HookFormSwitchProps<T>) => {
    const { title, style, name, control } = props
    const inputStyle = {
        margin: "10px",
        marginLeft: "20px",
        borderRadius: "6px",
        height: "32px",
        // maxWidth: "250px",
        width: "50%",
        ...style,
    };

    const containerStyle = {
        display: "flex",
        alignItems: "center",
        marginBottom: "10px",
        minWidth: "200px",
        maxWidth: "600px",
    };
    // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     setMethod(event.target.value);
    // };

    return (
        <div style={containerStyle}>
            <LabelContainer style={{ marginLeft: "28px" }}>
                {title + ": "}
            </LabelContainer>
            <Controller
                name={name}
                control={control}
                render={({ field: { value, onChange } }) => (
                    <Switch
                        checked={value}
                        onChange={onChange}
                    />
                )}
            />
        </div>
    )
}

export default HookFormSwitch